/**
 * Discover
 */

import {
	getRootVar
} from '../../../shared/utils/index';

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator    from '../../../shared/dom/manipulator';
import EventHandler   from '../../../shared/dom/event-handler';

import Drawer from '../../../shared/components/drawer';

// -------
// Private
// -------

const NAME      = 'discover';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

/**
 * Drawer ´Discover filter´
 */
const setupDrawer = () => {
	const ctrls = SelectorEngine.find('[aria-controls="discover-drawer"]');
	const drawerContainer = SelectorEngine.findOne('#discover-drawer');

	if (!drawerContainer) {
		for (const ctrl of ctrls) {
			Manipulator.setDisabled(ctrl, true);
		}

		return;
	}

	const drawerApi = new Drawer(drawerContainer, {
		closeButton: false,
		onShow     : function () {
			for (const ctrl of ctrls) {
				Manipulator.addClass(ctrl, '_active');
			}

		},
		onHidden   : () => {
			for (const ctrl of ctrls) {
				Manipulator.removeClass(ctrl, '_active');
			}
		}
	});

	// Drawer toggles initialisieren
	for (const ctrl of ctrls) {
		EventHandler.on(ctrl, `click${EVENT_KEY}`, (event) => {
			event.preventDefault();
			event.stopPropagation();

			if (event.delegateTarget.classList.contains('_active')) {
				drawerApi.hide();
			} else {
				if (window.drawer.menu) {
					window.drawer.next = drawerApi;
					window.drawer.menu.hide();
				} else {
					drawerApi.show();
				}
			}
		});
	}
};

// --------
// Let's go
// --------

document.addEventListener('DOMContentLoaded', function() {
	window.RootvarPrefix = window.RootvarPrefix || getRootVar('global-rootvar-prefix');

	setupDrawer();
});
